export { default as useUncontrolled, useUncontrolledProp } from './hook';
export { default as uncontrollable } from './uncontrollable';


//////////////////
// WEBPACK FOOTER
// ../~/uncontrollable/lib/esm/index.js
// module id = 3192
// module chunks = 121